import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-left_line_84",
  "use": "vab-icon-left_line_84-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-left_line_84\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.52729 8.47132C5.26694 8.21098 5.26694 7.78885 5.52729 7.52852L9.29854 3.75728C9.55888 3.49692 9.98101 3.49692 10.2413 3.75728C10.5017 4.01762 10.5017 4.43974 10.2413 4.70008L6.94148 7.99992L10.2413 11.2997C10.5017 11.5601 10.5017 11.9822 10.2413 12.2426C9.98101 12.5029 9.55888 12.5029 9.29854 12.2426L5.52729 8.47132Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol